import _IconCompass from "@arco-design/web-react/icon/react-icon/IconCompass";
import _IconSettings from "@arco-design/web-react/icon/react-icon/IconSettings";
import _IconRobot from "@arco-design/web-react/icon/react-icon/IconRobot";
import _IconLoop from "@arco-design/web-react/icon/react-icon/IconLoop";
import _IconThunderbolt from "@arco-design/web-react/icon/react-icon/IconThunderbolt";
import _IconCommon from "@arco-design/web-react/icon/react-icon/IconCommon";
import _IconUser from "@arco-design/web-react/icon/react-icon/IconUser";
import _IconDashboard from "@arco-design/web-react/icon/react-icon/IconDashboard";
import { useMemo } from 'react';
import { NavMenuKeys } from './navMenuKeys';
import { routes } from './route';
import React from 'react';
export { NavMenuKeys };
const iconStyle = {
  fontSize: '18px',
  verticalAlign: 'text-bottom'
};
export const useMenus = () => {
  return useMemo(() => {
    const navMenus = {
      [NavMenuKeys.Dashboard]: {
        path: NavMenuKeys.Dashboard,
        name: 'Dashboard',
        icon: /*#__PURE__*/React.createElement(_IconDashboard, {
          style: iconStyle
        }),
        children: [],
        enable: true
      },
      [NavMenuKeys.Operation]: {
        path: NavMenuKeys.Operation,
        name: '运营管理',
        icon: /*#__PURE__*/React.createElement(_IconUser, {
          style: iconStyle
        }),
        children: [],
        enable: true
      },
      [NavMenuKeys.Activity]: {
        path: NavMenuKeys.Activity,
        name: '活动管理',
        icon: /*#__PURE__*/React.createElement(_IconUser, {
          style: iconStyle
        }),
        children: [],
        enable: true
      },
      [NavMenuKeys.Finance]: {
        path: NavMenuKeys.Finance,
        name: '财务管理',
        icon: /*#__PURE__*/React.createElement(_IconCommon, {
          style: iconStyle
        }),
        children: [],
        enable: true
      },
      [NavMenuKeys.Stock]: {
        path: NavMenuKeys.Stock,
        name: '股票管理',
        icon: /*#__PURE__*/React.createElement(_IconThunderbolt, {
          style: iconStyle
        }),
        children: [],
        enable: true
      },
      [NavMenuKeys.Trade]: {
        path: NavMenuKeys.Trade,
        name: '交易管理',
        icon: /*#__PURE__*/React.createElement(_IconLoop, {
          style: iconStyle
        }),
        children: [],
        enable: false
      },
      [NavMenuKeys.Game]: {
        path: NavMenuKeys.Game,
        name: '行情游戏',
        icon: /*#__PURE__*/React.createElement(_IconRobot, {
          style: iconStyle
        }),
        children: [],
        enable: true
      },
      [NavMenuKeys.Settings]: {
        path: NavMenuKeys.Settings,
        name: '设置管理',
        icon: /*#__PURE__*/React.createElement(_IconSettings, {
          style: iconStyle
        }),
        children: [],
        enable: true
      },
      [NavMenuKeys.Fund]: {
        path: NavMenuKeys.Fund,
        name: '基金管理',
        icon: /*#__PURE__*/React.createElement(_IconCompass, {
          style: iconStyle
        }),
        children: [],
        enable: true
      },
      [NavMenuKeys.Shop]: {
        path: NavMenuKeys.Shop,
        name: '商品管理',
        icon: /*#__PURE__*/React.createElement(_IconCompass, {
          style: iconStyle
        }),
        children: [],
        enable: false
      },
      [NavMenuKeys.Project]: {
        path: NavMenuKeys.Project,
        name: '项目管理',
        icon: /*#__PURE__*/React.createElement(_IconCompass, {
          style: iconStyle
        }),
        children: [],
        enable: true
      }
    };
    routes.filter(v => v.enable).forEach(v => {
      if (v.module) {
        navMenus[v.module].children?.push(v);
      }
    });
    return Object.values(navMenus).filter(v => v.enable);
  }, []);
};